import { render, staticRenderFns } from "./RecommendedMessage.vue?vue&type=template&id=72660388&scoped=true"
import script from "./RecommendedMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendedMessage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RecommendedMessage.vue?vue&type=style&index=0&id=72660388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72660388",
  null
  
)

export default component.exports